import {Inject, Injectable, InjectionToken} from '@angular/core';
import {HttpEvent, HttpInterceptor, HttpHandler, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {map, delay} from 'rxjs/operators';
import {MockInterceptConfig, MockIntercept, MockInterceptOverride} from './http-mock.types';

export const MOCK_INTERCEPTOR_INTERCEPTS = new InjectionToken<[any]>('mock.interceptor.intercepts');
export const MOCK_INTERCEPTOR_RESOURCE_SERVER = new InjectionToken<string>('mock.interceptor.resourceServer');

@Injectable()
export class MMMockHttpInterceptor implements HttpInterceptor {
  mockInterceptConfig: MockInterceptConfig;

  constructor(@Inject(MOCK_INTERCEPTOR_INTERCEPTS) mockInterceptsIntercepts: [any],
              @Inject(MOCK_INTERCEPTOR_RESOURCE_SERVER) resourceServer: string) {
    this.mockInterceptConfig = new MockInterceptConfig(mockInterceptsIntercepts, resourceServer);

    console.log(`CPUI - MOCK MODE MMMockHttpInterceptor.constructor(): mockInterceptConfig`,
      {mockInterceptConfig: this.mockInterceptConfig});
  }

  /**
   * getMockUrl - Method to execute when to extract mockUrl;
   * @param req <HttpRequest> - The request
   * @param mockIntercept <MockIntercept> - the mock intercept config for the intercepted request.
   * @returns string
   */
  private getMockUrl(req: HttpRequest<any>, mockIntercept: MockIntercept): string {
    if (mockIntercept === null || mockIntercept === undefined) {
      return null;
    }

    const urlWithParamsDecoded = decodeURIComponent(req.urlWithParams),
      mockInterceptOverrides: MockInterceptOverride[] = mockIntercept['overrides'];
    let mockUrl = this.mockInterceptConfig.resourceServer + mockIntercept.mockUrl;

    if (mockInterceptOverrides) {
      const mockOverrideToApply = mockInterceptOverrides.find((override: MockInterceptOverride) => {
        const paramOverride = override.params, bodyOverride = override.body;

        if (paramOverride) {
          const paramOverrideKeys = Object.keys(paramOverride);
          const mockParamsOverride = paramOverrideKeys.find((paramKey) => {
            const regexOfParams = new RegExp(paramOverride[paramKey], 'gi');
            return urlWithParamsDecoded && urlWithParamsDecoded.match(regexOfParams) ? true : false;
          });

          if (mockParamsOverride) {
            return true;
          }
        }

        if (bodyOverride) {
          const bodyOverrideKeys = Object.keys(bodyOverride);
          const mockBodyOverride = bodyOverrideKeys.find((bodyKey) => {
            const regexOfBody = new RegExp(bodyOverride[bodyKey], 'i');
            return req.body && req.body[bodyKey] ? req.body[bodyKey].match(regexOfBody) : false;
          });

          if (mockBodyOverride) {
            return true;
          }
        }

        return false;
      });

      if (mockOverrideToApply) {
        mockUrl = this.mockInterceptConfig.resourceServer + mockOverrideToApply.mockUrl;
      }
    }

    return mockUrl;
  }

  /**
   * intercept - Interface implementation of the method to execute when
   * intercepting an http request in Mock Mode
   * @param req <HttpRequest> - The request
   * @param next <HttpHandler> - The handler for Http Events
   * @returns {Observable<HttpEvent<any>>}
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    console.log(`CPUI - MOCK MODE MMMockHttpInterceptor.intercept(): req to be mocked.`, {req});

    const urlToTest = req.url.replace(this.mockInterceptConfig.resourceServer, '');

    console.log(`CPUI - MOCK MODE MMMockHttpInterceptor.intercept(): URL to be mocked.`, {
      originalUrl: req.url,
      originalRequest: req
    });

    const mockIntercept: MockIntercept = this.mockInterceptConfig.intercepts.find((configMockIntercept: MockIntercept) => {
      const mockUrlRegex = new RegExp(configMockIntercept.url, 'gi');
      return urlToTest.match(mockUrlRegex) !== null;
    });

    const urlWithParamsDecoded = decodeURIComponent(req.urlWithParams);
    const mockUrl = this.getMockUrl(req, mockIntercept);

    if (mockUrl) {
      // Creating new request with MockUrl. *Forcing GET method since mocks are JSON assets.
      const mockReq = req.clone({url: mockUrl, method: 'GET'}), requestDelay = mockIntercept.delay || 0;

      console.log(`CPUI - MOCK MODE MMMockHttpInterceptor.intercept(): URL has been mocked.`, {
        originalUrl: req.url,
        originalRequest: req,
        mockUrl,
        urlWithParamsDecoded,
        requestDelay
      });

      return next.handle(mockReq).pipe(delay(requestDelay)).pipe(map(event => {
        return event;
      }));

    } else {
      console.warn(`CPUI - MOCK MODE MMMockHttpInterceptor.intercept(): MOCK NOT FOUND for ${req.url}`);
      return next.handle(req);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/mock/http-mock.interceptor.ts